import React from 'react';
import s from '../../styles/PolicyModal.module.css'; // создадим стиль

function OfertaModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className={s.overlay}>
      <div className={s.modal}>

      <h1  className={s.h1}>Оферта от 22.10.2026</h1>
          <p>
            Настоящая Оферта - адресованное неопределенному кругу лиц приглашение от Индивидуального предпринимателя Хабибуллиной Альфии Саррачевны (далее - "Исполнитель"), заключить договор возмездного оказания услуг в соответствии с п. 1 ст. 437 Гражданского кодекса Российской Федерации.
          </p>
          <p>
            Сервис pulseads.ru представляет собой программно-аппаратный комплекс (SaaS-платформу), предоставляющий Пользователю инструменты автоматизации работы с объявлениями на сторонних платформах, включая Avito, а также инструменты обработки, хранения и управления цифровыми данными Пользователя.
          </p>

          <h2>1. Термины и определения</h2>
          <ul>
            <li><strong>Оферта</strong> - публичное предложение Исполнителя заключить договор оказания услуг дистанционным способом на условиях настоящей Оферты.</li>
            <li><strong>Сервис</strong> - SaaS-платформа pulseads.ru.</li>
            <li><strong>Услуги</strong> - функциональные возможности Сервиса, включая автоматизацию публикации и управления объявлениями, CRM-инструменты и хранение файлов в рамках тарифа.</li>
            <li><strong>Сайт</strong> - <a href="https://pulseads.ru" target="_blank" rel="noopener noreferrer">pulseads.ru</a></li>
            <li><strong>Пользователь</strong> - физическое или юридическое лицо, принявшее условия Оферты.</li>
            <li><strong>Подписка</strong> - предоставление доступа к Сервису на оплаченный период с возможностью автопродления.</li>
            <li><strong>CRM-данные</strong> - сведения о клиентах и лидах, загружаемые Пользователем в Сервис.</li>
          </ul>

          <h2>2. Общие положения</h2>
          <ul>
            <li>2.1. Регистрация, оформление заказа и/или оплата услуг означают полное и безоговорочное принятие Пользователем условий настоящей Оферты.</li>
            <li>2.2. Исполнитель вправе вносить изменения в Оферту в одностороннем порядке без предварительного уведомления.</li>
            <li>2.3. Актуальная редакция Оферты публикуется на Сайте и применяется с момента публикации.</li>
            <li>2.4. Срок действия Оферты не ограничен, если иное не установлено законодательством РФ.</li>
          </ul>

          <h2>3. Отношение к Avito и внешним платформам</h2>
          <ul>
            <li>3.1. Исполнитель не является сотрудником, агентом или официальным представителем ООО "КЕХ еКоммерс" и/или платформы Avito.</li>
            <li>3.2. Упоминания Avito в Сервисе используются исключительно в описательных целях для обозначения совместимости.</li>
            <li>3.3. Пользователь осознает, что алгоритмы Avito, блокировки, ограничения, изменения правил и выдачи находятся вне контроля Исполнителя.</li>
            <li>3.4. Исполнитель не несет ответственности за действия администрации внешних платформ, включая Avito.</li>
          </ul>

          <h2>4. Отсутствие гарантий результата</h2>
          <ul>
            <li>4.1. Исполнитель не гарантирует получение прибыли, лидов, просмотров и иных коммерческих результатов.</li>
            <li>4.2. Результаты использования Сервиса зависят от внешних факторов, включая действия Пользователя, состояние рынка и правила сторонних платформ.</li>
          </ul>

          <h2>5. Ответственность Пользователя</h2>
          <ul>
            <li>5.1. Пользователь гарантирует наличие всех необходимых прав, лицензий и статусов для ведения своей деятельности.</li>
            <li>5.2. Пользователь несет полную ответственность за соблюдение законодательства РФ и достоверность предоставляемых данных.</li>
            <li>5.3. Пользователь самостоятельно отвечает за законность обрабатываемых персональных данных третьих лиц и наличие соответствующих согласий.</li>
          </ul>

          <h2>6. Условия хранения файлов (S3/Media Storage)</h2>
          <ul>
            <li>6.1. Дисковое пространство предоставляется исключительно как техническая функция для работы Сервиса.</li>
            <li>6.2. Хранение предназначено только для изображений и файлов, используемых при размещении объявлений.</li>
            <li>6.3. Запрещено использовать хранилище для личных архивов, несвязанных видеофайлов, баз данных и иных целей вне функционала Сервиса.</li>
            <li>6.4. Объем хранения определяется выбранным тарифом Пользователя.</li>
            <li>6.5. Файлы в инфраструктуре Сервиса не являются облачным архивом или универсальным файловым хостингом.</li>
          </ul>

          <h2>7. Жизненный цикл данных и удаление</h2>
          <ul>
            <li>7.1. При активной подписке данные хранятся в пределах оплаченного тарифа.</li>
            <li>7.2. По окончании оплаченного периода доступ к данным может быть ограничен.</li>
            <li>7.3. По истечении 30 календарных дней с момента окончания подписки данные могут быть удалены безвозвратно.</li>
            <li>7.4. Исполнитель вправе автоматически обрабатывать файлы, включая удаление EXIF и служебных метаданных без изменения визуального содержания.</li>
          </ul>

          <h2>8. Авторские права и take down policy</h2>
          <ul>
            <li>8.1. Пользователь несет полную ответственность за соблюдение авторских и иных прав на загружаемый контент.</li>
            <li>8.2. Исполнитель не проверяет правомерность использования Пользователем изображений и иных материалов.</li>
            <li>8.3. При поступлении обоснованной жалобы правообладателя Исполнитель вправе незамедлительно удалить или заблокировать соответствующий контент без предварительного уведомления Пользователя.</li>
          </ul>

          <h2>9. Персональные данные (152-ФЗ)</h2>
          <ul>
            <li>9.1. Оператором персональных данных является Исполнитель.</li>
            <li>9.2. Могут обрабатываться: email, телефон, данные аккаунта Avito (при подключении), CRM-данные, изображения и файлы.</li>
            <li>9.3. Цели обработки: предоставление SaaS-сервиса, автоматизация размещения объявлений, хранение пользовательских данных, внутренняя аналитика.</li>
            <li>9.4. Данные могут передаваться платежным системам, инфраструктурным провайдерам и платформам интеграций (включая Avito API) в объеме, необходимом для оказания услуг.</li>
            <li>9.5. Согласие на обработку персональных данных выражается Пользователем при регистрации и использовании Сервиса.</li>
            <li>9.6. Пользователь подтверждает, что самостоятельно получил согласия третьих лиц на обработку их персональных данных.</li>
          </ul>

          <h2>10. Подписка, платежи и возвраты</h2>
          <ul>
            <li>10.1. Оплата услуг осуществляется на условиях подписки за выбранный тариф и дополнительные услуги.</li>
            <li>10.2. Подписка может предусматривать автоматическое продление до момента ее отмены Пользователем.</li>
            <li>10.3. Оплата может производиться путем безналичного перечисления средств на расчетный счет Исполнителя по выставленному Счету (оплата которого является акцептом настоящей Оферты), а также через интернет-эквайринг и платежные сервисы.</li>
            <li>10.4. Обязательства Пользователя по оплате считаются исполненными с момента поступления денежных средств на счет Исполнителя.</li>
            <li>10.5. Исполнитель применяет специальный налоговый режим «Налог на профессиональный доход» (НПД) в соответствии с ФЗ № 422-ФЗ. Первичным закрывающим документом, подтверждающим факт оказания услуг и расходы Пользователя (юридического лица или ИП), является электронный Чек, сформированный Исполнителем в системе «Мой налог».</li>
            <li>10.6. Возврат возможен только за фактически неоказанные услуги.</li>
            <li>10.7. Исполнитель не несет ответственности за задержки и сбои платежей, вызванные сторонними платежными системами (включая ЮKassa и иные сервисы).</li>
          </ul>

          <h2>11. Запрет нецелевого использования</h2>
          <ul>
            <li>11.1. Сервис предназначен исключительно для работы с объявлениями и связанными процессами автоматизации на внешних платформах, включая Avito.</li>
            <li>11.2. Использование Сервиса в целях, не предусмотренных функционалом и настоящей Офертой, запрещено.</li>
          </ul>

          <h2>12. Ограничение ответственности и порядок разрешения споров</h2>
          <ul>
            <li>12.1. Исполнитель не несет ответственности за косвенные убытки, упущенную выгоду, потерю данных или репутационные потери Пользователя, возникшие при использовании Сервиса.</li>
            <li>12.2. Совокупная ответственность Исполнителя по любым требованиям Пользователя ограничивается суммой фактически оплаченных Пользователем услуг за 30 календарных дней, предшествующих возникновению основания ответственности.</li>
            <li>12.3. До обращения в суд Стороны соблюдают обязательный досудебный претензионный порядок; срок рассмотрения претензии - 10 рабочих дней с даты ее получения.</li>
            <li>12.4. Споры подлежат рассмотрению в соответствии с законодательством Российской Федерации по месту регистрации Исполнителя, если иное не предусмотрено императивными нормами права.</li>
          </ul>

          <h2>13. Юридически значимые сообщения и электронный документооборот</h2>
          <ul>
            <li>13.1. Стороны признают юридическую силу уведомлений, документов и сообщений, направленных через интерфейс Сервиса, по электронной почте, через системы электронного документооборота (ЭДО), а также в виде сканированных копий документов.</li>
            <li>13.2. Документы, подписанные усиленной квалифицированной электронной подписью (УКЭП) или переданные в форме сканов с подписями Сторон, приравниваются к оригиналам документов на бумажном носителе.</li>
            <li>13.3. Пользователь обязуется поддерживать актуальность контактных данных в личном кабинете.</li>
            <li>13.4. Риск последствий, связанных с неактуальностью контактных данных Пользователя, несет Пользователь.</li>
          </ul>

                    <h2>14. Реквизиты Исполнителя</h2>
          <p>
            ИП Хабибуллина Альфия Саррачевна<br />
            ИНН: 165701046010<br />
            ОГРНИП: 324169000228591<br />
            Р/с: 40802810700006916666 в АО «ТБанк»<br />
            К/с: 30101810145250000974<br />
            БИК: 044525974<br />
                        Email: support@pulseads.ru
          </p>

          <a href="/oferta.pdf" download="Oferta_PulseADS.pdf">
            Скачать оферту в формате PDF
          </a>

        <div className={s.button_div}>
        <button className={s.close_button} onClick={onClose}>Закрыть</button>
        </div>
      </div>
    </div>
  );
}

export default OfertaModal;